import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useUiStore } from '@/store/useUiStore';

/** Animated maroon⇄cream orb; the Field cross-fades palettes on change (plan §8). */
export default function ThemeToggle() {
  const { t } = useTranslation();
  const theme = useUiStore((s) => s.theme);
  const toggleTheme = useUiStore((s) => s.toggleTheme);
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      className="toggle-btn theme-toggle"
      onClick={toggleTheme}
      aria-pressed={isDark}
      aria-label={isDark ? t('nav.toggleThemeToLight') : t('nav.toggleThemeToDark')}
      title={t('nav.toggleTheme')}
    >
      <span className="theme-orb" data-dark={isDark} aria-hidden="true">
        {isDark ? <Moon size={16} /> : <Sun size={16} />}
      </span>
    </button>
  );
}
